module.exports = __webpack_public_path__ + "static/media/diktat-19.a00e7c8a.mp3";